import React from 'react';
import { CheckOutlined, RightOutlined } from '@ant-design/icons';
import { StepNavContainer, StepItem } from './index.styled';

export type AppStepNavStep = {
  key: string | number;
  label: React.ReactNode;
};

export type AppStepNavProps = {
  steps: AppStepNavStep[];
  currentStep: string | number;
  showActiveIndicator?: boolean;
  className?: string;
  width?: number | string;
};

const AppStepNav: React.FC<AppStepNavProps> = ({
  steps,
  currentStep,
  showActiveIndicator = true,
  className,
  width = 250,
}) => {
  const currentIndex = steps.findIndex((s) => s.key === currentStep);
  const resolvedIndex = currentIndex >= 0 ? currentIndex : 0;

  return (
    <StepNavContainer className={className} $width={width}>
      {steps.map((step, index) => {
        const isActive = step.key === currentStep;
        const isDone = index < resolvedIndex;
        return (
          <StepItem key={step.key} $active={isActive} $done={isDone}>
            <span className="step-number">
              {isDone ? <CheckOutlined /> : index + 1}
            </span>
            <span>{step.label}</span>
            {showActiveIndicator && isActive && (
              <RightOutlined style={{ marginLeft: 'auto', fontSize: 12 }} />
            )}
          </StepItem>
        );
      })}
    </StepNavContainer>
  );
};

export default AppStepNav;
